<template>
  <v-row class="ma-0 pa-0" justify="center" style="width: 100%; height: 100%">
    <v-col class="ma-0 pa-0" cols="12" sm="12" lg="10" md="12" xl="8" style="width: 100%; max-height: 100%">
      <div class="box-container" style="width: 100%; height: 100%">
        <div class="row-content px-2" ref="refGridContainer" align="center" justify="center" flat>
          <v-data-table
            :height="gridHeight"
            class="elevation-0"
            :mobile-breakpoint="0"
            :dense="isOnMobile ? true : userSettings.denseGrid"
            hide-default-footer
            :items="event_list"
            :headers="dataheaders"
            fixed-header
            disable-pagination
            style="width: 100%; padding-top: 4px"
          >
            <template v-slot:no-data>
              <v-row align="center" justify="center" class="ma-0 pa-0">
                <v-alert :value="true" color="default">{{ userHasBalance ? TR.DeviceEvents_NoEvents : TR.NoBalance }}</v-alert>
              </v-row>
            </template>
            <template v-for="(h, index) in dataheaders" v-slot:[`item.${h.value}`]="{ item }">
              <span v-if="h.value == 'isChecked'" :key="index" class="data-grid-cell ma-0 pa-0" style="cursor: pointer" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'">
                <v-checkbox :key="index" class="ma-0 pa-0 align-items-center" :disabled="isSaveDisabled" v-model="item.isChecked" @click.native="changeProfile(item)" dense hide-details></v-checkbox>
              </span>
              <template v-else-if="h.value == 'text'">
                <span :key="'s' + index" class="data-grid-cell ma-0 pa-0" @click="showAction(item)" style="cursor: pointer" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'">
                  <v-icon :key="'i' + index" class="pl-2">mdi-magnify</v-icon>
                  {{ formatCell(h.proptype, Object.byString(item, h.value)) }}
                </span>
              </template>
              <template v-else-if="h.value == 'dev.Technician'">
                <span :key="'s' + index" class="data-grid-cell ma-0 pa-0" @click="showTechnician(item)" style="cursor: pointer" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'">
                  {{ formatCell(h.proptype, Object.byString(item, h.value)) }}
                </span>
              </template>
              <span v-else :key="'ss' + index" class="data-grid-cell" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'">
                {{ formatCell(h.proptype, Object.byString(item, h.value)) }}
                <!-- <v-icon v-if="h.value == 'action' && item.amount > 0 && item.details[0].text.startsWith('Invoice')" class="pl-2">mdi-file-pdf</v-icon> -->
              </span>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import DataManager, { ErrorMessage, DataHeader, DataPropType } from "../../js/DataManager";
import Translation from "../../js/Translation";
import bus, { TR } from "../../main";

export default {
  data() {
    return {
      TR: TR,
      DataPropType: DataPropType,
      event_list: [],
      datatype: null,
      isSaveDisabled: false,
      gridHeight: 500,
      dataheaders: [
        new DataHeader(TR.ReceiveDate, "date", DataPropType.Date, "center"),
        new DataHeader(TR.Device, "dev", DataPropType.String, "left"),
        new DataHeader(TR.SN, "dev.sn", DataPropType.String, "left"),
        new DataHeader(TR.Event, "text", DataPropType.String, "left"),
        new DataHeader(TR.Technician, "dev.Technician", DataPropType.String, "left"),
        new DataHeader(TR.Seen, "isChecked", DataPropType.BOOL, "center"),
      ],
    };
  },
  methods: {
    setTitleAndData(meta, error) {
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.datatype = meta.datatype;
        this.refreshData();
      } else {
        this.dialogLoader.showError(error.Message, { location: "center" });
      }
    },
    formatCell(proptype, value) {
      return DataManager.formatGridData(proptype, value);
    },
    showTechnician(ev) {
      if (ev.dev.Technician) {
        this.dialogLoader.showInfo(ev.dev.Technician.n + "\ntel:" + ev.dev.Technician.p + "\n" + ev.dev.Technician.c);
      }
    },
    showAction(ev) {
      if (ev.text == TR.BLOCK_TEXT) {
        this.showLastReceipt(ev.dev);
      } else if (ev.text == TR.FM_FULL_TEXT) {
        this.dialogLoader.showInfo(TR.Device + " " + ev.dev + " (" + ev.dev.sn + ", " + ev.dev.Address + ") " + TR.DeviceEvents_HasReached + " 2000" + " " + TR.DeviceEvents_ReportsInFm + "!", { timeout: 10000 });
      } else if (ev.text == TR.FM_NEAR_FULL_TEXT) {
        this.dialogLoader.showInfo(TR.Device + " " + ev.dev + " (" + ev.dev.sn + ", " + ev.dev.Address + ") " + TR.DeviceEvents_HasReached + " " + ev.dev.duprofile.zRcvdTo + " " + TR.DeviceEvents_ReportsInFm + "!", { timeout: 10000 });
      }
    },
    showLastReceipt(dev) {
      if (dev.LastReceipt) {
        this.dialog.show("receipt-view", dev.LastReceipt);
      }
    },
    userHasBalance() {
      var user = DataManager.getData(DataManager.DataType.user);
      return user && user.balance > 0;
    },
    refreshData() {
      this.event_list = [];
      // for (var i = 0; i < 20; i++)
      DataManager.getData(this.datatype, true).forEach((d) => {
        if (d.IsBlocked) {
          this.event_list.push({ dev: d, date: d.LastReceipt.dateReceived, isChecked: d.IsBlockedChecked == d.LastReceipt.dateReceived.getTime(), text: TR.BLOCK_TEXT });
        }
         else
        if (d.IsFMFull) {
          this.event_list.push({ dev: d, date: d.lastTalkDate, isChecked: d.IsFMEventChecked, text: TR.FM_FULL_TEXT });
        } else if (d.IsFMNearFull) {
          this.event_list.push({ dev: d, date: d.lastTalkDate, isChecked: d.IsFMEventChecked, text: TR.FM_NEAR_FULL_TEXT });
        }
      });
      this.event_list.sortByDesc("date");
      this.recalcGridHeight();
    },
    changeProfile(ev) {
      this.isSaveDisabled = true;
      if (ev.text == TR.BLOCK_TEXT) {
        ev.dev.IsBlockedChecked = ev.isChecked ? ev.dev.LastReceipt.dateReceived.getTime() : null;
      } else {
        ev.dev.IsFMEventChecked = ev.isChecked;
      }
      if (TR.Locale == Translation.bg.Locale) {
        DataManager.updateDevProfile(ev.dev, () => {
          // if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          //   bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.devices);
          // }
          setTimeout(() => {
            this.isSaveDisabled = false;
          }, 3000);
        });
      } else {
        DataManager.updateDevNameAndSettingsGlobal(ev.dev.sn, null, ev.dev.settings1, () => {
          setTimeout(() => {
            this.isSaveDisabled = false;
          }, 3000);
        });
      }
    },
    recalcGridHeight() {
      setTimeout(() => {
        if (this.$refs.refGridContainer && this.$refs.refGridContainer.clientHeight > 0) {
          this.gridHeight = this.$refs.refGridContainer.clientHeight - 8;
        }
      }, 500);
    },
    setFocus(on) {
      this.onfocus = on;
      if (on) this.recalcGridHeight();
    },
  },
  mounted() {
    bus.$on(bus.EVENT_DataManager_DATA_CHANGED, (datatype) => {
      if (datatype == this.datatype) {
        this.refreshData();
      }
    });

    window.addEventListener("resize", this.recalcGridHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcGridHeight);
  },
};
</script>

<style>
</style>